/**
 * Sidebar Icon
 *
 */

import type { SVGProps } from 'react'

export default function principles(props: SVGProps<SVGSVGElement> = {}) {
  return (
    <svg
      viewBox="0 0 48 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 46V10"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 46H31"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.4502 5.27399L38.5002 1"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 11.4999L18.98 6.93994"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 10C23.66 10 25 8.657 25 7C25 5.343 23.66 4 22 4C20.34 4 19 5.343 19 7C19 8.657 20.34 10 22 10Z"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 31C16 32.989 15.21 34.897 13.8 36.303C12.4 37.71 10.49 38.5 8.5 38.5C6.51 38.5 4.60001 37.71 3.20001 36.303C1.79001 34.897 1 32.989 1 31H16Z"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.41998 10.1538L1 24.9998"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.55957 10.1143L15.9996 25.0002"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43 22C43 23.989 42.21 25.897 40.8 27.303C39.4 28.71 37.49 29.5 35.5 29.5C33.51 29.5 31.6 28.71 30.2 27.303C28.79 25.897 28 23.989 28 22H43Z"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.96 2.07812L28 16.0001"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.0004 15.9998L35.9004 1.7998"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
